import { createContext, useContext, useEffect, useState } from "react";

export interface ILangContext {
  lang: "en" | "fa";
  setLang: (payload: "en" | "fa") => void;
  dir: "ltr" | "rtl";
  setDir: () => void;
  toggleLang: () => void;
}

const langContext = createContext<ILangContext>({
  lang: "en",
  setLang: () => false,
  dir: "ltr",
  setDir: () => false,
  toggleLang: () => false,
});

export function LangContextProvider({ defaultLang = "en", ...props }: any) {
  const [lang, setLang] = useState(localStorage.getItem("lang") || defaultLang);
  const [dir, setDir] = useState(lang == "fa" ? "rtl" : "ltr");

  const toggleLang = () => {
    setLang(lang === "en" ? "fa" : "en");
    setDir(lang === "fa" ? "rtl" : "ltr");
    localStorage.setItem("lang", lang);
  };

  useEffect(() => {
    setDir(lang == "fa" ? "rtl" : "ltr");
    localStorage.setItem("lang", lang);
  }, [lang]);

  return (
    <langContext.Provider
      value={{ lang, setLang, dir, setDir, toggleLang }}
      {...props}
    />
  );
}

export const useLangContext = () => useContext(langContext);
